export function encode(value) {
  const Entities = require('html-entities').XmlEntities;
  const entities = new Entities();

  return entities.decode(value)
}
